/**
 * Tuning knobs for battle-catalog ranking. Printed stats and activates each
 * score `deck × statWeight + ghost`. Gain Prestige / Strong Finishers then add
 * `payoff × prestigePayoff` (or `finisherPayoff`) on top of that fit, so a
 * 1-Prestige card that matches a heavy deck can still outrank a 2-Prestige
 * splash. Raise a payoff weight to bubble engines; raise `statWeight` to make
 * the current deck pull harder.
 */

export const CATALOG_SORT = {
  /** How hard each deck point pulls matching printed stats and activates. */
  statWeight: 0.15,
  /** Empty-axis baseline so a first badge does not 0× every other stat. */
  ghost: 1,
  /**
   * Extra copies of the activate-stat fit weight. 1 means Activate counts as
   * +1 printed point on that axis.
   */
  activate: 1,
  /**
   * Fit points per potential Prestige in Gain Prestige. Steal already counts 2×
   * in the payoff.
   */
  prestigePayoff: 2,
  /** Same unit as `prestigePayoff`, for Strong Finishers. */
  finisherPayoff: 2,
} as const;

export type CatalogSortRole = 'prestige' | 'finishers';
